import { captureExecutionScroll, restoreExecutionScroll, bindExecutionReorder } from '../../ui/execution-list.js';
import { createExecutionTitleEditor } from '../../ui/execution-title.js';
import { moveExecutionItem } from '../../../../engine/core/execution-list.js';

const titleEditor = createExecutionTitleEditor();
const sectionKey = section => JSON.stringify([section.dataset.docId, section.dataset.noteId]);

export function captureMobileExecutionScroll(container) {
  const section = container.querySelector('.mobile-today');
  if (!section) return null;
  return { key: sectionKey(section), rename: titleEditor.capture(), position: captureExecutionScroll(
    section.querySelector('.mobile-today-list'), section.closest('.mobile-note-reader')) };
}

export function restoreMobileExecutionScroll(container, saved) {
  const section = container.querySelector('.mobile-today');
  if (section && saved?.key === sectionKey(section)) {
    restoreExecutionScroll(section.querySelector('.mobile-today-list'), saved.position,
      section.closest('.mobile-note-reader'));
  }
}

export function bindMobileExecutionReorder(container, { callbacks, scheduleRender, getActiveDocIdForNotes }, saved) {
  const section = container.querySelector('.mobile-today');
  if (!section) return () => {};
  const sc = callbacks.sharedCallbacks;
  const stopReorder = bindExecutionReorder(section.querySelector('.mobile-today-list'), {
    scroller: section.closest('.mobile-note-reader'),
    isReadOnly: () => !!callbacks.Store.isReadOnly?.(),
    onMove: (nodeId, targetId, after) => {
      const currentDoc = getActiveDocIdForNotes?.() || callbacks.Store.get('currentDocId') || '';
      if (callbacks.Store.isReadOnly?.() || !section.isConnected || currentDoc !== section.dataset.docId) return;
      const noteId = section.dataset.noteId;
      const ordered = moveExecutionItem(sc.getTaskListItems(noteId), nodeId, targetId, after,
        id => !!sc.nodeIsDone?.(sc.find?.(id)));
      if (ordered) { sc.setTaskListOrder(noteId, ordered); scheduleRender(); return true; }
      return false;
    },
  });
  titleEditor.bind(section.querySelector('.mobile-today-list'), {
    find: id => sc.find?.(id),
    isReadOnly: id => !!(callbacks.Store.isReadOnly?.() || sc.isNodeReadOnly?.(id)),
    isCurrent: () => (getActiveDocIdForNotes?.() || callbacks.Store.get('currentDocId') || '') === section.dataset.docId,
    onRename: (id, name) => sc.onUpdateNode?.(id, { name }),
    onSelect: id => (sc.onNodeOpenFromList || sc.onNodeSelect)?.(id),
  }, saved?.key === sectionKey(section) ? saved.rename : null);
  return () => { stopReorder(); titleEditor.dispose(); };
}
